<div class="bbg-wrap">

  <!-- Skeleton -->
  @if (loading) {
    <div class="bbg-skeleton">
      <div class="bbg-sk-title"></div>
      <div class="bbg-sk-grid">
        @for (_ of [1,2,3,4]; track $index) {
          <div class="bbg-sk-card"></div>
        }
      </div>
    </div>
  }

  @if (!loading && config) {

    <!-- Header -->
    <div class="bbg-header">
      <span class="bbg-title">{{ config.title }}</span>
      <span class="bbg-count">{{ rows.length }} imágenes</span>
    </div>

    <!-- Tag filter -->
    <div class="bbg-tag-bar">
      @for (t of tags; track t.key) {
        <button type="button" class="bbg-tag-btn"
                [class.is-active]="activeTag === t.key"
                [style.--tc]="t.color"
                (click)="setTag(t.key)">
          <span class="bbg-tag-dot" [style.background]="t.color"></span>
          {{ t.label }}
        </button>
      }
    </div>

    <!-- Grid de imágenes -->
    @if (rows.length === 0) {
      <div class="bbg-empty">Sin imágenes para mostrar.</div>
    } @else {
      <div class="bbg-grid">
        @for (row of rows; track trackByUrl($index, row)) {
          <article class="bbg-card" (click)="openDetail(row)">
            <div class="bbg-img-wrap">

              <!-- Imagen -->
              <img class="bbg-img"
                   [src]="row.imageUrl"
                   alt="Reconocimiento"
                   (load)="onImgLoad($event, row)"
                   (error)="onImgError($event)" />

              <!-- Bounding boxes -->
              @for (obj of visibleObjects(row); track trackByIdx($index)) {
                <div class="bbg-bbox" [ngStyle]="bboxStyle(obj, row)">
                  <span class="bbg-bbox__label" [ngStyle]="bboxLabelStyle(obj)">
                    {{ obj.name }}
                  </span>
                </div>
              }

            </div>

            <!-- Footer con conteo de objetos por tag -->
            <div class="bbg-card__foot">
              @for (t of tags.slice(1); track t.key) {
                @let cnt = row.objects | objectCountByTag: t.key;
                @if (cnt > 0) {
                  <span class="bbg-foot__chip" [style.--tc]="t.color">
                    {{ t.label }}: {{ cnt }}
                  </span>
                }
              }
            </div>
          </article>
        }
      </div>
    }

  }

</div>

<!-- ── Modal detalle ─────────────────────────────────────────────────── -->
@if (selectedRow) {
  <div class="bbg-overlay" (click)="closeDetail()">
    <div class="bbg-modal" (click)="$event.stopPropagation()">

      <button class="bbg-modal__close" (click)="closeDetail()">
        <i class="pi pi-times"></i>
      </button>

      <div class="bbg-modal__img-wrap">
        <img class="bbg-modal__img"
             [src]="selectedRow.imageUrl"
             alt="Detalle"
             (load)="onImgLoad($event, selectedRow)" />
        @for (obj of visibleObjects(selectedRow); track trackByIdx($index)) {
          <div class="bbg-bbox bbg-bbox--modal" [ngStyle]="bboxStyle(obj, selectedRow)">
            <span class="bbg-bbox__label" [ngStyle]="bboxLabelStyle(obj)">
              {{ obj.name }} {{ scorePct(obj.score) }}
            </span>
          </div>
        }
      </div>

      <!-- Lista de objetos detectados -->
      <div class="bbg-modal__list">
        <p class="bbg-modal__list-title">Objetos detectados ({{ selectedRow.objects.length }})</p>
        @for (obj of selectedRow.objects; track trackByIdx($index)) {
          <div class="bbg-modal__obj"
               [class.is-dim]="activeTag !== 'all' && obj.tag !== activeTag">
            <span class="bbg-modal__obj-dot" [style.background]="tagColor(obj.tag)"></span>
            <span class="bbg-modal__obj-name">{{ obj.name }}</span>
            <span class="bbg-modal__obj-tag" [style.color]="tagColor(obj.tag)">{{ obj.tag }}</span>
            <span class="bbg-modal__obj-score">{{ scorePct(obj.score) }}</span>
          </div>
        }
      </div>

    </div>
  </div>
}
